import {configureStore} from '@reduxjs/toolkit';
import {setupListeners} from '@reduxjs/toolkit/query';
import {logger} from './logger';
import {api} from '../features/api/apiSlice';
import repairIdReducer from '../features/api/repairIdSlice';
import scheduleReducer from '../features/scheduling/schedulerSlice';

const env = process.env.NODE_ENV;

// Enable redux logger only in development, model, and test environments
const loggerEnvs = new Set(['development', 'model', 'test']);
const shouldUseLogger = loggerEnvs.has(env);

export const makeStore = () => {
  const store = configureStore({
    reducer: {
      [api.reducerPath]: api.reducer,
      repairId: repairIdReducer,
      scheduler: scheduleReducer,
    },
    middleware: (getDefaultMiddleware) => {
      if (shouldUseLogger) {
        return getDefaultMiddleware().concat(api.middleware, logger);
      }
      return getDefaultMiddleware().concat(api.middleware);
    },
  });
  setupListeners(store.dispatch);

  return store;
};

export const store = makeStore();
